/* Modules */
import BgImgSlider from './modules/BgImgSlider';
import PWForm from './modules/PasswordForm';
import Accordion from './modules/Accordion';
import TerritoryBlockMap from './modules/TerritoryBlockMap';
import InternationalMapBlock from './modules/InternationalMapBlock';
import InteractiveHeroSlider from './modules/InteractiveHeroSlider';
import AdminEditButton from './modules/AdminEditButton';
import TmmCards from './modules/TmmCards';
import SigGenerator from './modules/SigGenerator';
import TourismMeansMoreHero from "./modules/TourismMeansMoreHero";
import VideoIframeModal from "./modules/VideoIframeModal";
import ScrollEffect from "./modules/VideoComponent";

document.addEventListener('DOMContentLoaded', () => {
  const bgImgSliders = document.querySelectorAll('.js-bg-img-slider');
  if (bgImgSliders.length > 0) {
    const bgImgSlidersArray = [...bgImgSliders];

    bgImgSlidersArray.forEach((bgImgSlider) => {
      new BgImgSlider(bgImgSlider);
    });
  }

  const pw_form = document.querySelector('#tn-pwForm');
  if (pw_form !== null) {
    new PWForm(pw_form);
  }

  const sig_generator = document.querySelector('.js-sig-generator');
  if (sig_generator !== null) {
    new SigGenerator(sig_generator);
  }

  const accordions = document.querySelectorAll('.js-accordion');
  if (accordions.length > 0) {
    const accordionsArray = [...accordions];

    accordionsArray.forEach((accordion) => {
      new Accordion(accordion, true);
    });
  }

  const territoryBlocks = document.querySelectorAll('.js-territory-block-map');
  if (territoryBlocks.length > 0) {
    territoryBlocks.forEach((territoryBlock) => {
      new TerritoryBlockMap(territoryBlock);
    });
  }

  const internationalMapBlocks = document.querySelectorAll(
    '.js-international-map-block-map'
  );
  if (internationalMapBlocks.length > 0) {
    internationalMapBlocks.forEach((intMapBlock) => {
      new InternationalMapBlock(intMapBlock);
    });
  }

  const featuredSliders = document.querySelectorAll('.js-featured-slider');
  if (featuredSliders.length > 0) {
    const featuredSlidersArray = [...featuredSliders];

    featuredSlidersArray.forEach((featuredSlider) => {
      new InteractiveHeroSlider(featuredSlider);
    });
  }

  const adminEditButtons = document.querySelectorAll(
    '.admin-edit-info .admin-edit-info-button'
  );
  if (adminEditButtons.length > 0) {
    adminEditButtons.forEach((button) => {
      new AdminEditButton(button);
    });
  }

  const tmmCards = document.querySelectorAll('.tourism-means-more-hero__card');
  if (tmmCards.length) {
    new TmmCards(tmmCards);
  }

  const tmmHero = document.querySelector('.js-tmm-hero.--v2-styles');
  if (tmmHero) {
    new TourismMeansMoreHero(tmmHero);
  }

  const videoIframeModals = document.querySelectorAll('.js-video-iframe-modal');
  if (videoIframeModals.length > 0) {
    videoIframeModals.forEach((videoIframeModal) => {
      new VideoIframeModal(videoIframeModal);
    });
  }

  const videoComponent = document.querySelectorAll('.js-scroll-effect');
  if (videoComponent.length > 0) {
    new ScrollEffect();
  }
});
